import type { PropsWithChildren, ReactNode } from 'react';

type Props = PropsWithChildren;

/**
 * A simple 12 column grid, should be used to render the Coupon and Stats nav.
 *
 * @param root0 the input props
 * @param root0.children the subcomponents {CouponGridLeft}
 * @returns a layout grid.
 */
export default function CouponGrid({ children }: Props): ReactNode {
  return <div className="mt-4 grid grid-cols-12 gap-4 lg:mt-8">{children}</div>;
}
